var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox-group',{model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},_vm._l((_vm.options),function(option){return _c('el-checkbox',{attrs:{"label":option.value}},[_vm._v("\n        "+_vm._s(option.label)+"\n    ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }